module.exports = __webpack_public_path__ + "img/leaf-small.4da0a052.svg";